import { Toast, ToastProvider } from '@aurecon-creative-technologies/styleguide'
import { useAuth0 } from '@auth0/auth0-react'
import { FC, useState } from 'react'
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import LoadingScreen from './components/LoadingScreen'
import CustomNavbar from './components/Navbar'
import Page from './components/Page'
import TermsCookiesModal from './components/TermsCookiesModal'
import AddProject from './pages/AddProject'
import BulkUpdate from './pages/BulkUpdate'
import Consent from './pages/Consent'
import CookiesPolicy from './pages/CookiesPolicy'
import GIS from './pages/GIS'
import Login from './pages/Login'
import NotFound from './pages/NotFound'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Profile from './pages/Profile'
import Property from './pages/Property'
import ServiceStatus from './pages/ServiceStatus'
import Storage from './pages/Storage'
import TermsAndConditions from './pages/TermsAndConditions'

import ErrorGfx from './assets/kitten.svg'

import Style from './styles/App.module.sass'

const App: FC = () => {
  const { isLoading, error, isAuthenticated } = useAuth0()
  const [isConsented, setIsConsented] = useState(false)

  // useEffect(() => {
  //   console.log('isConsented', isConsented)
  //   console.log('isAuthenticated', isAuthenticated)
  // }, [isConsented])

  if (error) {
    return (
      <div className={Style.errorWrapper}>
        <div className={Style.innerWrapper}>
          <p>Aurecon Smoke Testing</p>
          <p>
            <img src={ErrorGfx} alt='Error' />
          </p>
          <p>Oops... Looks like we have an issue...</p>
        </div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <Page>
        <LoadingScreen text='Loading application...' />
      </Page>
    )
  }

  const publicRoutes = [
    <Route key='home_public' path='/login' element={<Login />} />,
    <Route key='terms' path='/termsandconditions' element={<TermsAndConditions />} />,
    <Route key='privacy' path='/privacy' element={<PrivacyPolicy />} />,
    <Route key='cookies' path='/cookies' element={<CookiesPolicy />} />,
    <Route key='gis' path='/gis' element={<GIS />} />,
    <Route key='storage' path='/storage' element={<Storage />} />,
    <Route key='status' path='/status' element={<ServiceStatus />} />,
  ]

  const privateRoutes = [
    <Route key='root' path='/' element={<Property />} />,
    <Route key='profile' path='/profile' element={<Profile />} />,
    <Route key='property' path='/property' element={<Property />} />,
    <Route key='addproj' path='/addproj' element={<AddProject />} />,
    <Route key='bulkupdate' path='/bulkupdate' element={<BulkUpdate />} />,
  ]

  if (!isAuthenticated) {
    return (
      <RecoilRoot>
        <HashRouter>
          <Routes>
            {publicRoutes}
            <Route path='/' element={<Navigate to='/login' state={location} />} />
          </Routes>
        </HashRouter>
      </RecoilRoot>
    )
  }

  if (!isConsented) {
    return (
      <RecoilRoot>
        <Consent
          setConsented={() => {
            setIsConsented(true)
          }}
        />
      </RecoilRoot>
    )
  }

  // In the case with two routes with the same path, private will override public
  return (
    <RecoilRoot>
      <ToastProvider>
        <HashRouter>
          <CustomNavbar
            links={[
              { url: '#/property', label: 'PROPERTY LIST' },
              { url: '#/addproj', label: 'ADD PROJECT' },
              { url: '#/bulkupdate', label: 'BULK UPDATE' },
            ]}
          />
          <Routes>
            {privateRoutes}
            {publicRoutes}
            <Route path='*' element={<NotFound />} />
          </Routes>
          <TermsCookiesModal />
        </HashRouter>
        <Toast />
      </ToastProvider>
    </RecoilRoot>
  )
}

export default App
